export class RefreshCart {
  constructor() {
    document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
      bubbles: true
    }));
  }
}
const refreshCart = new RefreshCart();
refreshCart;